import { RegionShared } from "@1games-ru/region-shared";
import { useLayoutEffect } from "react";
import rpc from "@1games-ru/rage-rpc";
import PlayerMpProvider from "@/core/data-provider/data-mp/player/player-mp-provider";
import useAppSelector from "@/core/helpers/useAppSelector";
import {
  ExtendedNotificationType,
  useNotificationStore,
} from "@/stores/notifications/notificationStore";
import { playerInfoSelector } from "@/domains/player/slice";

export default function useAddOfferSubscriber() {
  const playerInfo = useAppSelector(playerInfoSelector);

  const { addNotification, removeNotification } = useNotificationStore();

  useLayoutEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Offer.OfferPending,
      async (state: typeof RegionShared.Cef.Requests.OfferPendingRequest) => {
        if (playerInfo.character.id === state.baseCharacterId) {
          return;
        }

        const character = await PlayerMpProvider.getCharacter(state.baseCharacterId);

        if (!character) {
          console.error("Character not found");
          return;
        }

        addNotification({
          id: state.uuid,
          type: ExtendedNotificationType.Offer,
          data: {
            type: state.type,
            baseCharacterId: state.baseCharacterId,
            targetCharacterId: state.targetCharacterId,
            baseCharacterName: character.name.content,
            targetId: state.targetId,
            quantity: state.quantity,
            amount: state.amount,
            payload: state.payload,
            status: state.status,
            createdAt: state.createdAt,
            destroyAt: state.destroyAt,
          },
        });
      },
    );

    rpc.register(
      RegionShared.Cef.Events.Offer.OfferResolved,
      async (state: typeof RegionShared.Cef.Requests.OfferResolvedRequest): Promise<void> => {
        removeNotification(state.uuid);
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Offer.OfferPending);
      rpc.unregister(RegionShared.Cef.Events.Offer.OfferResolved);
    };
  }, [addNotification, playerInfo, removeNotification]);

  return {};
}
